export const formatError = err => ({
  errors: err.errors || [err.error],
});
